import { ContainerModule } from 'inversify';
import { ExamSessionReducerPlugin } from './exam-session-reducer-plugin'
import { QuizSessionReducerPluginSymbol } from '@/app/quiz-session/api';

export const examSessionDomainModule = new ContainerModule((bind) => {
  bind(QuizSessionReducerPluginSymbol).to(ExamSessionReducerPlugin).whenTargetNamed('exam')
});
